import React, { useCallback, useEffect, useState } from 'react';
import { Button, ListItem } from '@rneui/themed';
import { ThemeMode } from '@annunciate/core';
import { useSettingsMutation } from '@annunciate/query';
import { useThemeOrDefault } from '../../hooks';
import { ManagePurchases } from './ManagePurchases';
import { AccountLinks } from './AccountLinks';
import { ActivityIndicator } from 'react-native';
export const Settings = () => {
    const theme = useThemeOrDefault();
    const [themeTitle, setThemeTitle] = useState();
    const { mutate } = useSettingsMutation();
    useEffect(() => {
        setThemeTitle(theme);
    }, [theme]);
    const nextTheme = useCallback((theme) => {
        if (theme === ThemeMode.DARK) {
            return ThemeMode.LIGHT;
        }
        else if (theme === ThemeMode.LIGHT) {
            return ThemeMode.SYSTEM;
        }
        else {
            return ThemeMode.DARK;
        }
    }, []);
    const onUpdateTheme = useCallback(() => {
        const update = {
            user: {
                settings: {
                    theme: nextTheme(theme),
                },
            },
        };
        mutate(update);
    }, [theme]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ListItem, null,
            React.createElement(ListItem.Content, null,
                React.createElement(ListItem.Subtitle, null, "Theme")),
            React.createElement(Button, { onPress: onUpdateTheme }, themeTitle ? themeTitle : React.createElement(ActivityIndicator, null))),
        React.createElement(ManagePurchases, null),
        React.createElement(AccountLinks, null)));
};
//# sourceMappingURL=Settings.js.map